import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from '../../../store'
import CustomButton from '../../UI/Buttons/CustomButton'

import DialogIcon from '../../../assets/img/dialog-icon.svg'

import {
  QUESTION_ANSWER_FORM_TYPE,
  TPushAnswerByApproverPayload,
  TPushQuestionByContentCreatorPayload
} from '../../../store/managePost/newTypes'
import {
  pushAnswerByApproverThunk,
  pushQuestionByContentCreatorThunk
} from '../../../store/managePost/thunks'

import './PostActionQuestionAnswerForm.scss'
import { useToasts } from 'react-toast-notifications'
import { isFulfilled, isRejected } from '@reduxjs/toolkit'
import { TOAST_MESSAGE } from '../../UI/ToastNotification/ToastNotification'
import QuestionIcon from '../../UI/Icons/Question'

interface PostActionQuestionAnswerFormProps {
  approvalId: number
  formType: QUESTION_ANSWER_FORM_TYPE
}

const PostActionQuestionAnswerForm: FC<PostActionQuestionAnswerFormProps> = ({
  approvalId,
  formType
}) => {
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const { selectedPostSocialId, loaders } = useSelector(
    ({ managePost: { selectedPostSocialId, loaders } }) => ({
      selectedPostSocialId,
      loaders
    })
  )
  const [questionText, setQuestionText] = useState<string>('')
  const [openQuestionInput, setOpenQuestionInput] = useState<boolean>(false)

  const pushQuestionByContentCreator = async () => {
    const payload: TPushQuestionByContentCreatorPayload = {
      approval_id: approvalId,
      message: questionText,
      post_social_id: selectedPostSocialId
    }
    const data = await dispatch(pushQuestionByContentCreatorThunk(payload))
    if (isFulfilled(data)) {
      addToast(TOAST_MESSAGE.QUESTION_SENT, { appearance: 'success' })
    } else if (isRejected(data)) {
      addToast(TOAST_MESSAGE.GENERAL_ERROR_MASSEGE, { appearance: 'error' })
    }
    clearInputAndClose()
  }

  const pushAnswerByApprover = async () => {
    const payload: TPushAnswerByApproverPayload = {
      approval_id: approvalId,
      message: questionText,
      post_social_id: selectedPostSocialId
    }
    const data = await dispatch(pushAnswerByApproverThunk(payload))
    if (isFulfilled(data)) {
      addToast(TOAST_MESSAGE.ANSWER_SENT, { appearance: 'success' })
    } else if (isRejected(data)) {
      addToast(TOAST_MESSAGE.GENERAL_ERROR_MASSEGE, { appearance: 'error' })
    }
    clearInputAndClose()
  }

  const clearInputAndClose = () => {
    setOpenQuestionInput(false)
    setQuestionText('')
  }
  return (
    <div className='post-action_content-body-question'>
      <div className='question-container'>
        <div
          className={`question-container_button ${
            openQuestionInput && 'question-container_button_chosen'
          }`}
          onClick={() => setOpenQuestionInput(true)}
        >
          {formType === QUESTION_ANSWER_FORM_TYPE.TYPE_QUESTION ? (
            <>
              <QuestionIcon />
              Ask a question
            </>
          ) : (
            <>
              <img src={DialogIcon} alt='' />
              Reply
            </>
          )}
        </div>
        {openQuestionInput && (
          <CustomButton onClick={clearInputAndClose} button='move' type='button'>
            Close
          </CustomButton>
        )}
      </div>
      {openQuestionInput && (
        <div className='question-container_submit-section'>
          <input
            className='post-input-container_input'
            value={questionText}
            maxLength={255}
            onChange={({ target: { value } }) => setQuestionText(value)}
            placeholder='Write a question...'
          />
          <CustomButton
            onClick={
              formType === QUESTION_ANSWER_FORM_TYPE.TYPE_QUESTION
                ? pushQuestionByContentCreator
                : pushAnswerByApprover
            }
            inProgress={loaders.approval.saveQuestionOrAnswer}
            button='primary'
            type='button'
          >
            Send a question
          </CustomButton>
        </div>
      )}
    </div>
  )
}

export default PostActionQuestionAnswerForm
